import { useEffect, useState } from 'react';
import useDomElement from './useDomElement';

const useOptinMonsterDriftInteraction = () => {
  const [optinMonsterOpen, toggleOptinMonsterOpen] = useState(false);
  const domElement = useDomElement('.drift-frame-controller');

  useEffect(() => {
    const showOptinMonster = () => {
      toggleOptinMonsterOpen(true);
    };
    const closeOptinMonster = () => {
      dataLayer.push({
        event: 'promotion viewed',
        promotion_engaged: 'closed',
      });
      toggleOptinMonsterOpen(false);
    };

    const onOptinMonsterCtaClick = () => {
      dataLayer.push({
        event: 'promotion viewed',
        promotion_engaged: 'clicked_cta',
      });
    };

    document.addEventListener('om.Html.append.before', showOptinMonster);
    document.addEventListener('om.Campaign.close', closeOptinMonster);
    document.addEventListener('om.Optin.init', onOptinMonsterCtaClick);

    return () => {
      document.removeEventListener('om.Html.append.before', showOptinMonster);
      document.removeEventListener('om.Campaign.close', closeOptinMonster);
      document.addEventListener('om.Optin.init', onOptinMonsterCtaClick);
    };
  }, []);

  useEffect(() => {
    if (optinMonsterOpen && domElement) {
      domElement.style.display = 'none';
    } else if (!optinMonsterOpen && domElement) {
      domElement.style.display = 'block';
    }
  }, [domElement, optinMonsterOpen]);
};

export default useOptinMonsterDriftInteraction;
